import React from 'react';

interface Props {
  message: string;
  onExport: (kind: 'current' | 'saved' | 'backup') => void;
  hasCurrentData: boolean;
  onImport: (file: File) => void;
}

/** 保存失敗時は通常操作に戻らず、先にデータの退避を案内する。 */
export function SaveRecoveryScreen({ message, onExport, hasCurrentData, onImport }: Props) {
  return (
    <main style={{ maxWidth: 640, margin: '48px auto', padding: 24 }}>
      <h1>セーブデータを確認してください</h1>
      <p role="alert">{message}</p>
      <p>自動初期化は行っていません。データを退避してから、保存領域やアプリのバージョンを確認してください。</p>
      {hasCurrentData && (
        <p><button onClick={() => onExport('current')}>現在の進行状況をJSONで退避</button></p>
      )}
      <p><button onClick={() => onExport('saved')}>保存されている元データを退避</button></p>
      <p><button onClick={() => onExport('backup')}>直前のバックアップを退避</button></p>
      <p><label>バックアップJSONから復元（現在の保存内容を退避して置換）
        <input type="file" accept="application/json,.json" onChange={event => {
          const file = event.currentTarget.files?.[0];
          if (file) onImport(file);
          event.currentTarget.value = '';
        }} />
      </label></p>
      <p>再読み込みすると未保存の進行は失われます。先に必要なデータを退避してください。</p>
      <button onClick={() => window.location.reload()}>再読み込み</button>
    </main>
  );
}
